import { render } from "./HomeFooter.vue?vue&type=template&id=644d0586&scoped=true&ts=true"
import script from "./HomeFooter.vue?vue&type=script&lang=ts"
export * from "./HomeFooter.vue?vue&type=script&lang=ts"

import "./HomeFooter.vue?vue&type=style&index=0&id=644d0586&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644d0586"]])

export default __exports__